export const LOCALHOST = 'localhost';
export const DEV_HOST = 'https:/pumb-automator-dev.agileengine.com';
export const LOCALHOST_PORTS = {
  BACKEND: 8000,
  FRONTEND: 3000,
};
